import React, { useRef, useEffect, useState } from "react";
import styled from "@emotion/styled";
import { ThemeContext, LanguageContext, UserContext, ActionContext } from "../contexts/Context";
import useWindowDimensions from "../hooks/useWindowDimensions";
import MenuInfoContainer from "./MenuInfoContainer";
import Modal from './optioncomponents/Modal';
import promo from '../newcomponents/customerComponents/Promotion';
const EditItemModal = ({
    show,
    setShow,
    item,
    index,
    cart
}) => {
    //State
    const [displayShow, setDisplay] = useState(show ? "grid" : "none");
    const themeContext = React.useContext(ThemeContext);
    const languageContext = React.useContext(LanguageContext);
    const { theme, lanIndex, pm, isLanReverse, containerItems, isTakeAway, tkType } = React.useContext(UserContext);
    const { width } = useWindowDimensions();
    const { removeFromCart } = React.useContext(ActionContext);
    const [sh, setSh] = useState(false);
    const [error, setError] = useState([]);
    const itemRef = useRef(null);

    const handleEdit = () => {
        if (!checkIfSelected()) return;
        cart.splice(index, 1, JSON.parse(JSON.stringify(itemRef.current)));

        if (pm && pm.length > 0) {
            cart = promo.clearPromotion(cart);
            cart = promo.applyPromotion(pm, cart);

            cart = promo.removeContainer(cart);
            cart = promo.applyContainer(cart, containerItems,  isTakeAway && tkType != 1);
        }
        cart = JSON.parse(JSON.stringify(cart));

        localStorage.setItem("order", JSON.stringify(cart));
        removeFromCart(cart, index);
        itemRef.current = null;
        setShow(false);
    }

    useEffect(() => {
        if (item != null) {
            setDisplay(show ? "grid" : "none");
            itemRef.current = JSON.parse(JSON.stringify(item));
        }
    }, [item, show]);

    const checkIfSelected = () => {
        const skipOption = ["No Dressing Please!", "No Crunches"];
        let errorMessages = [];
        let optionArray = itemRef.current.optionArray;

        let alertSubject = `${languageContext[lanIndex].setMeal}: `;
        let quantityCheck = itemRef.current.qty;

        if (itemRef.current.isSetMeal === true) {
            optionArray.forEach((element) => {
                if (element.optionActive === true && element.optionRequired && element.options.length > 0) {
                    let selected = 0;
                    let hasNoOption = false;
                    element.options.forEach((option) => {
                        if (option.active) {
                            selected += (option.qty ? option.qty : 1);
                            if (skipOption.indexOf(option.title) > -1) hasNoOption = true;
                        }
                    });

                    let foundActiveOptionArraySelection = element.options.find((option) => option.active === true);

                    if (!foundActiveOptionArraySelection || (element.isMultiple && selected < element.minQty && !hasNoOption)) {
                        errorMessages.push({
                            errorElement: element.optionTitle,
                            errorMessage: (
                                <>
                                    <b style={{ color: "#CF000D" }}>
                                        {alertSubject + (lanIndex == 0 ? element.optionTitle : element.optionTitle2)}
                                    </b>&nbsp;
                                    <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                                </>
                            ),
                        });
                    } else {
                        
                        //nested Option
                        foundActiveOptionArraySelection.optionArray &&
                            foundActiveOptionArraySelection.optionArray.forEach((element2) => {
                                if (element2.optionActive === true && element2.optionRequired) {
                                    let selected2 = 0;
                                    element2.options.forEach((option) => { if (option.active) selected2 += (option.qty ? option.qty : 1); });
                                    let setMealDepthOptionFound = element2.options.find((option) => option.active === true);
                                    if ((element2.isMultiple && selected2 < element2.minQty) || !setMealDepthOptionFound) {
                                        errorMessages.push({
                                            errorElement: element2.optionTitle,
                                            errorMessage: (
                                                <>
                                                    <b style={{ color: "#CF000D" }}>
                                                        {(lanIndex === 0 ? element2.optionTitle : element2.optionTitle2)}
                                                    </b>
                                                    {" of "}
                                                    <b style={{ color: "#CF000D" }}>
                                                        {alertSubject + (lanIndex === 0 ? element.optionTitle : element.optionTitle2)}
                                                    </b>&nbsp;
                                                    <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                                                </>
                                            ),
                                        });
                                    }
                                }
                            });
                    }
                } else if (element.optionActive === true && element.options.length > 0) {
                    //even option is not compulsory, but nested may be compulsory
                    let foundActiveOptionArraySelection = element.options.find((option) => option.active === true);
                    foundActiveOptionArraySelection && foundActiveOptionArraySelection.optionArray &&
                        foundActiveOptionArraySelection.optionArray.forEach((element2) => {
                            if (element2.optionActive === true && element2.optionRequired) {
                                let selected2 = 0;
                                element2.options.forEach((option) => { if (option.active) selected2 += (option.qty ? option.qty : 1); });
                                let setMealDepthOptionFound = element2.options.find((option) => option.active === true);
                                if ((element2.isMultiple && selected2 < element2.minQty) || !setMealDepthOptionFound) {
                                    errorMessages.push({
                                        errorElement: element2.optionTitle,
                                        errorMessage: (
                                            <>
                                                <b style={{ color: "#CF000D" }}>
                                                    {((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element2.optionTitle : element2.optionTitle2)}
                                                </b>
                                                {" of "}
                                                <b style={{ color: "#CF000D" }}>
                                                    {alertSubject + ((lanIndex == 0 && !isLanReverse) || (lanIndex == 1 && isLanReverse) ? element.optionTitle : element.optionTitle2)}
                                                </b>&nbsp;
                                                <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                                            </>
                                        ),
                                    });
                                }
                            }
                        });
                }
            });
        } else {
            optionArray.forEach((element) => {
                if (element.optionActive === true && element.optionRequired) {
                    let checkActive = false;
                    let selected = 0;
                    let hasNoOption = false;
                    element.options.forEach((option) => {
                        if (option.active === true) {
                            checkActive = true;
                            if (skipOption.indexOf(option.title) > -1) hasNoOption = true;
                            selected += (option.qty ? option.qty : 1);
                        }
                    });

                    if ((checkActive === false && !element.isMultiple) || (element.isMultiple && selected < element.minQty && !hasNoOption)) {
                        errorMessages.push({
                            errorElement: element.optionTitle,
                            errorMessage: (
                                <>
                                    <b style={{ color: "#CF000D" }}>{lanIndex === 0 ? element.optionTitle : element.optionTitle2}</b>
                                    &nbsp;
                                    <b>{languageContext[lanIndex].required}</b>, {languageContext[lanIndex].pleasePick}.
                                </>
                            ),
                        });
                    }
                }
            });
        }

        if (quantityCheck < 1) {
            errorMessages.push({
                errorElement: "Quantity",
                errorMessage: (
                    <>
                        <b style={{ color: "#CF000D" }}>Quantity</b> cannot be less than{" "}
                        <b>1</b> please re-adjust.
                    </>
                ),
            });
        }

        if (errorMessages.length > 0) {
        
            setError(errorMessages);
            setSh(true);
            return false;
        }
        return true;
    };

    return (
        <React.Fragment>
            <ModalContainer display={displayShow} onClick={() => setShow(false)}>
                <ModalMain themeContext={themeContext} onClick={(event) => event.stopPropagation()}>
                    {(item != null && itemRef.current != null) &&
                        <MenuInfoContainer
                            width={Math.min(width, 720)}
                            menuSelectionFormRef={itemRef}
                            selectedMenu={item}
                            theme={theme}
                            isEdit={true}
                            setShow={setShow}
                            cp={1}
                            onAddToCart={handleEdit}
                            addToCartText={languageContext[lanIndex].edit}
                        />
                    }
                </ModalMain>
            </ModalContainer>
            <Modal show={sh} setShow={setSh} error={error} />
        </React.Fragment>
    );
};

export default EditItemModal;

const ModalContainer = styled.div`
    display: ${(props) => props.display};
    position: fixed;
    inset: 0;
    box-sizing: border-box;
    place-items: center;
    width: 100vw;
    max-width: none;
    height: 100dvh;
    padding: 0;
    background: rgba(0, 0, 0, 0.58);
    z-index: 120;

    @media (min-width: 768px) {
      padding: 40px;
    }
  `;

const ModalMain = styled.div`
    position: relative;
    font-family: ${(props) => props.themeContext.fontFamily};
    background: ${(props) => props.themeContext.backgroundColor};
    z-index: 1;
    width: 100%;
    height: 100dvh;
    overflow: hidden;

    @media (min-width: 768px) {
      width: calc(100vw - 80px);
      max-width: 1200px;
      height: auto;
      max-height: calc(100dvh - 80px);
      border-radius: 16px;
      box-shadow: 0 18px 52px rgba(0, 0, 0, 0.35);
      animation: editItemDialogIn 180ms ease-out;

      @keyframes editItemDialogIn {
        from {
          transform: translateY(18px) scale(0.98);
          opacity: 0;
        }
        to {
          transform: translateY(0) scale(1);
          opacity: 1;
        }
      }
    }
`;
